export default function(data) {
var __t, __p = '';
__p += '<button id="unsub-btn" class="rounded-button">' +
((__t = ( this.getText(data.subscribed) )) == null ? '' : __t) +
'</button>\n';
return __p
}